const paymentFailed = () => {
  return (
    <div>
      <h1>Payment is Failed</h1>
    </div>
  );
};
export default paymentFailed;
